<template>
    <div id="page-find-sap-gia">
        <vx-card ref="filterCard" class="mb-1">
            <vs-row vs-w="12">
                <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-lg="6" vs-sm="12" vs-xs="12" >
                    <vs-input class="w-full" placeholder="Member name" v-model="members"/>
                </vs-col>
                <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-lg="6" vs-sm="12" vs-xs="12" >
                    <date-range-picker 
                        @date-change="onDateFilterChange" 
                        :initDate="{from: fromDate, to: toDate}"
                        actionBtnText="Xem"
                    />
                </vs-col>
            </vs-row>
        </vx-card>

        <div class="vx-card pl-5 pr-5">
            <vs-table 
                :data="dataView"
                :max-items="itemsPerPage"
                pagination
                :stripe="true"
                search
                description
                description-title="Query"
                description-connector="of"
            >
                <template slot="header">
                    <!-- ITEMS PER PAGE -->
                    <div class="">
                        <vs-dropdown vs-trigger-click class="cursor-pointer">
                            <div class="p-3 border border-solid d-theme-border-grey-light rounded-full cursor-pointer flex items-center justify-between font-medium">
                                <span class="mr-2">
                                    {{ itemsPerPage }}
                                </span>
                                <feather-icon
                                    icon="ChevronDownIcon"
                                    svgClasses="h-4 w-4"
                                />
                            </div>
                            <vs-dropdown-menu>
                                <vs-dropdown-item :key="ipp" v-for="ipp in [15,25,50,100]" @click="itemsPerPage = ipp"><span>{{ipp}}</span></vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>
                    </div>
                </template>
                <template slot="thead">
                    <vs-th
                        :key="idx"
                        v-for="(h,idx) in header"
                        :sort-key="h.field"
                    >
                        {{ h.title }}
                    </vs-th>
                </template>
                <template slot-scope="{ data }">
                    <vs-tr
                        :class="tr.new_block == true ?'block_border':null" 
                        :key="indextr" 
                        v-for="(tr, indextr) in data">
                        <vs-td :key="idx" v-for="(h,idx) in header" :data="data[indextr][h.field]">
                            <p :class="tr.bet_key && h.field == 'member_name' ?'bet_key':null">
                                <template v-if="h.render">
                                    {{ h.render(data[indextr]) }}
                                </template>
                                <template v-else>
                                    {{ data[indextr][h.field] }}
                                </template>
                            </p>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Swal from 'sweetalert2';
import vSelect from 'vue-select';
import { AclRule } from 'vue-acl';
import numeral from 'numeral';
import moment from "moment";
import DateRangePicker from '@/components/DateRangePicker';

export default {
    data(){
        return {
            itemsPerPage: 100,
            header: [
                { title:"Member", field:"member_name", render: function(data){ return data.member_name.toUpperCase(); } },
                { title:"Ngày", field:"bet_time", render: function(data){ return moment(data.bet_time).format("DD-MM-YYYY_HH:mm:ss") } },
                { title:"IP", field:"bet_ip" },
                { title:"Sàn", field:"board_id", render: function(data){ return data.board_id == 1 ? "ibet" : data.board_id == 2 ? "sbo" : "unknown"; }},
                { title:"Chọn", field:"bet_choice", render: function(data){ return `${data.bet_choice} ${data.bet_handicap} ${data.bet_favorite}` } },
                { title:"Trận", field:"bet_match" },
                { title:"Loại", field:"bet_type" }, 
                { title:"Odds", field:"bet_odds" },
                { title:"Stake", field:"bet_stake" },
                { title:"Status", field:"bet_status" },
                { title:"VN Time", field:"bet_time", render: function(data){ return moment(data.bet_time).add(11, 'hours').format("HH:mm:ss") } }
            ],
            dataAll: [],
            dataView: [],
            fromDate: this.$route.query.from || moment().format("YYYY-MM-DD"),
            toDate: this.$route.query.to || moment().format("YYYY-MM-DD"),
            members: this.$route.query.members || "",
        }
    },
    components: {
        vSelect,
        DateRangePicker
    },
    computed: {
        fetchQueryDataPermission(){
            return new AclRule('store_find_sap_gia').generate();
        },
    },
    methods:{
        fetchQuery() {
            if(this.$acl.not.check('fetchQueryDataPermission')) return;

            let vm = this;
            let payload = {
                "member_name": this.members,
                "from": this.fromDate,
                "to": this.toDate
            };

            this.$http.post('bets/find_sap_gia', payload).then((res) => {
                if(res.data.code < 0){
                    Swal.fire("", res.data.msg, "error");
                    return;
                }
                vm.dataView = res.data.data;
            });
        },
        onDateFilterChange(data){
            this.fromDate = data.fromDate;
            this.toDate = data.toDate;

            if(this.members == ""){
                Swal.fire("", "Vui lòng nhập thông tin để tìm kiếm!", "error");
                return;
            }

            this.fetchQuery();
        }
    }
};
</script>

<style>
.container{
    margin: 0;
}
.row2{
    padding-top: 10px;
}
.swal2-container{
    z-index: 99999;
}
#page-find-sap-gia .block_border{
    border-top: 10px solid #ddd;
}
#page-find-sap-gia .bet_key{
    color: rgb(255, 71, 87);
}
</style>
